
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine } from "@common/src/utils/common";
import { namespace } from "vuex-class";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";

const parts = namespace("parts");

@InjectFunction("emptyToLine", "splitThousands", "addCurrencyUnit")
@Component({})
@Table("loadListData")
export default class ComPartsGroupPreview extends Vue {
  emptyToLine = emptyToLine;
  @parts.Action getPartsList;
  @Prop({
    default: "",
    type: String
  })
  groupName: string;
  @Prop({
    default: false,
    type: Boolean
  })
  visible: boolean;
  @Prop({
    default: "",
    type: String
  })
  partsRuleCode: string;

  @Prop({
    default: -1,
    type: Number
  })
  partsRuleType: number;

  searchForm: any = {
    partsName: "",
    partsNumber: ""
  };
  searchList: any = [
    {
      label: t("parts.name"),
      type: "input",
      value: "",
      prop: "partsName"
    },
    {
      label: t("parts.code"),
      type: "input",
      value: "",
      prop: "partsNumber"
    }
  ];
  get mode() {
    return this.partsRuleType === 2 ? "partsGroup" : "category";
  }
  partsList: any = [];
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPartsList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      partsRuleCode: this.partsRuleCode,
      partsRuleType: this.partsRuleType
    }).then(data => {
      this.partsList = data.data?.list || [];
      return data;
    });
  }
  handleClose() {
    this.$emit("update:visible", false);
    this.searchForm.partsName = "";
    this.searchForm.partsNumber = "";
    this.$refs.searchBar && (this.$refs.searchBar as any).reset();
  }
  @Watch("partsRuleCode")
  partsRuleCodeChange() {
    this.loadListData();
  }
}
